{
  "common": {
    "for": "voor",
    "each": "elk",
    "eachLot": "elk kavel",
    "lot": "kavel",
    "lots": "kavels",
    "selectAll": "Selecteer alles",
    "unselectAll": "Deselecteer alles"
  },
  "pageHeader": {
    "techSupport": "Technische Ondersteuning",
    "auctionCompany": "Veilinghuis",
    "welcome": "Welkom",
    "bidder": "Bieder",
    "viewer": "Kijker",
    "fullCatalog": "Bekijk Volledige Catalogus"
  },
  "catalogAndMyPurchases": {
    "firstTab": "Catalogus",
    "secondTab": "Mijn Aankopen",
    "trackLots": "Volg huidig kavel in veiling",
    "backToLots": "Terug naar kavels",
    "passed": "Opgehouden",
    "pending": "Nog niet bevestigd",
    "sold": "Verkocht",
    "biddingNow": "Bieden nu bezig",
    "upNext": "Volgend kavel",
    "confirmPurchases": "Alle aankopen moeten worden bevestigd door het veilinghuis",
    "lot": "Kavel",
    "backToMyPurchases": "Terug naar mijn aankopen"
  },
  "chat": {
    "loading": "Chat laden ...",
    "header": "Online Chat"
  },
  "mediaStreaming": {
    "failedConnection": "Verbinding mislukt!",
    "playBtn": "Speel live media af",
    "connecting": "Verbinden ...",
    "unmute": "Geluid aan",
    "mute": "Geluid uit",
    "tooltip": "Uit bent met succes verbonden met het streaming platform"
  },
  "biddingArea": {
    "auctionPaused": "Veiling is gepauzeerd",
    "waitingAuctionToStart": "Wachten tot de veiling begint",
    "waitingBiddingToStart": "Wachten tot het bieden begint",
    "auctioneerConfirmed": "De veilingmeester heeft u toegewezen",
    "soldPriceForEach": "Verkoopprijs voor elk",
    "winningBid": "Winnend bod",
    "pendingSellerConfirmationForEach": "In afwachting van bevestiging van de verkoper voor de prijs voor elk",
    "pendingBid": "Bod nog niet definitief",
    "auctioneerRefused": "De veilingmeester heeft u niets toegewezen.",
    "sold": "Verkocht!",
    "pendingSellerConfirmation": "Uw bieding is in afwachting van bevestiging van verkoper.",
    "bid": "Bod",
    "roundCancelled": "Biedronde is geannuleerd",
    "noSale": "Opgehouden",
    "highestBidder": "Gefeliciteerd, u bent de hoogste bieder!",
    "youWon": "CGefeliciteerd, u hebt het kavel verkregen!",
    "waitingWinner": "Wachten tot de winnaar zijn kavels kiest…",
    "totalPrice": "Totaalprijs",
    "yourBidPending": "Uw bieding is in afwachting van bevestiging van verkoper",
    "waitingWinnerChooseLots": "In afwachting van bevestiging van verkoper…",
    "youAreIn": "U bent binnen!",
    "viewOnly": "Alleen kijken! ",
    "registerLogin": "Registreren/Inloggen ",
    "clickToBid": "Klik om te bieden ",
    "swipeToBid": "Veeg om te bieden ",
    "waitingIncrement": "Wachten op invoeren biedstap",
    "totalBid": "Totaal bod",
    "bidHistory": "Biedgeschiedenis",
    "floorFirst": "Zaal eerst",
    "waitAuctioneer": "Wacht a.u.b. op het goedkeuren van de veilingmeester.",
    "makeSelections": "Maak een selectie",
    "pricePendingConfirmation": "Prijs in afwachting van bevestiging van verkoper voor elk kavel",
    "selectionSent": "Selectie verstuurd",
    "sendSelection": "Verzend selectie"
  },
  "currentRound": {
    "nowBidding": "Er wordt nu geboden ",
    "scrollList": "Scroll lijst hieronder"
  },
  "webcastFinished": "Het webcast-evenement is gesloten. Bedankt"
}
